import { render, staticRenderFns } from "./AlertaAccion.vue?vue&type=template&id=1ac0560a&scoped=true&"
import script from "./AlertaAccion.vue?vue&type=script&lang=js&"
export * from "./AlertaAccion.vue?vue&type=script&lang=js&"
import style0 from "./AlertaAccion.vue?vue&type=style&index=0&id=1ac0560a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0560a",
  null
  
)

export default component.exports